import { render, staticRenderFns } from "./BrokerStatus.vue?vue&type=template&id=70355fe0&scoped=true"
import script from "./BrokerStatus.vue?vue&type=script&lang=js"
export * from "./BrokerStatus.vue?vue&type=script&lang=js"
import style0 from "./BrokerStatus.vue?vue&type=style&index=0&id=70355fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70355fe0",
  null
  
)

export default component.exports